import React from 'react';
import { motion } from 'framer-motion';
import { Scissors, Wine, Beer, Sparkles } from 'lucide-react';
const services = [{
  icon: Scissors,
  title: 'Cortes Old School + Arreglo de Barba',
  desc: 'No es solo un corte. Es un ritual. Tijera, máquina, técnica clásica y toalla caliente para que la barba quede como nunca. Para el hombre que entiende que los detalles hacen la diferencia.'
}, {
  icon: Sparkles,
  title: 'Afeitado Tradicional',
  desc: 'El afeitado que los hombres de antes conocían. La toalla caliente abre. La crema prepara. La navaja trabaja con precisión milimétrica. El resultado es una piel sin irritación.',
  bgImage: 'https://cdn.magicpatterns.com/uploads/r9yJyF6c3HPYv1Mw8JNRff/banner_2.png'
}, {
  icon: Wine,
  title: 'Getting Ready — Servicio para el Novio',
  desc: 'Cerramos el salón. Solo para vos y tus amigos. El día de tu casamiento tenés que llegar fresco, prolijo y presentable. Incluye barra de tragos, lunch, música a elección y el mejor look de tu historia.'
}, {
  icon: Beer,
  title: 'Barra Rotterdam',
  desc: 'Porque esperar con algo rico en la mano no es un lujo — es como siempre debió ser. Café, cerveza fría o un trago de autor mientras te atendemos.',
  bgImage: 'https://cdn.magicpatterns.com/uploads/mBexFco98AdnySv7uTbZ9i/barra.png'
}];
const galleryImages = ['https://cdn.magicpatterns.com/uploads/h5vZALwBRoc8FQGhKzFrWG/img_7.png', 'https://cdn.magicpatterns.com/uploads/cboRtxydBVuNUmuGovtcof/img_4.png', 'https://cdn.magicpatterns.com/uploads/tLyrXRPg1An6L3emabsnps/imag_2.png', 'https://cdn.magicpatterns.com/uploads/mG3gFJjZz5vYVA7SGcwAtJ/img_8.png', 'https://cdn.magicpatterns.com/uploads/x9FMVHQZr2s1UcTasdodpu/img_5.png', 'https://cdn.magicpatterns.com/uploads/i5puPHoSidPqmiuQJutA5w/imag_3.png'];
const shavingGalleryImages = ['https://cdn.magicpatterns.com/uploads/pBtCLHz5fXT7pdFtVqPZhj/barba_1.png', 'https://cdn.magicpatterns.com/uploads/wPiM52j5aiZ3442GFDfsfL/barba_4.png', 'https://cdn.magicpatterns.com/uploads/w8DTLG4gziEizC1M9LL4pT/barba_5.png', 'https://cdn.magicpatterns.com/uploads/dhpowjM4tzURX793uVHcrs/barba_2.png', 'https://cdn.magicpatterns.com/uploads/xeMNVt9Mu4wN1z1YCYFhFS/barba_6.png', 'https://cdn.magicpatterns.com/uploads/7t1PQ9mAeTsHJGs8PpNF9z/barba_9.png', 'https://cdn.magicpatterns.com/uploads/8xcsbsPj4PDyALJFjpoitc/barba_10.png'];
export function Services() {
  return <section id="services" className="pt-24 pb-12 px-6 bg-rotterdam-dark" data-id="element-210">
      <div className="max-w-6xl mx-auto" data-id="element-211">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-10" data-id="element-212">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6" data-id="element-213">
            Los Servicios
          </h2>
          <p className="text-rotterdam-gold pearl-text text-xl md:text-2xl font-serif italic max-w-3xl mx-auto" data-id="element-214">
            Que tu prioridad sea cuidar tu imagen y nosotros lo hacemos por vos
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-6" data-id="element-215">
          {/* First service card: Cortes Old School */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="relative border-2 border-rotterdam-gold pearl-border p-8 overflow-hidden transition-colors duration-300 flex flex-col" data-id="element-216">
            <img src="https://cdn.magicpatterns.com/uploads/jgvscCXeAmgh1bTqrZojmt/fondo_de_corte_mas_barba.png" alt="" className="absolute inset-0 w-full h-full object-cover opacity-40" data-id="element-217" />
            <div className="absolute inset-0 bg-rotterdam-black/40" data-id="element-218" />
            <div className="relative z-10" data-id="element-219">
              <Scissors className="w-10 h-10 text-rotterdam-gold pearl-icon mb-6" data-id="element-220" />
              <h3 className="text-2xl font-serif font-semibold mb-4" data-id="element-221">
                {services[0].title}
              </h3>
              <p className="text-rotterdam-cream/90 leading-relaxed" data-id="element-222">
                {services[0].desc}
              </p>
            </div>
          </motion.div>

          {/* Marquee gallery below Cortes Old School */}
          <div className="overflow-hidden w-full" data-id="element-223">
            <div className="flex animate-marquee gap-4" style={{
            width: 'max-content'
          }} data-id="element-224">
              {[...galleryImages, ...galleryImages, ...galleryImages].map((img, index) => <div key={index} className="flex-shrink-0 w-64 h-80 overflow-hidden border border-rotterdam-gold/30 group relative" data-id="element-225">
                    <img src={img} alt={`Corte Rotterdam ${index % galleryImages.length + 1}`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-226" />
                    <div className="absolute inset-0 bg-[#6BB8D4]/0 group-hover:bg-[#6BB8D4]/10 transition-colors duration-300" data-id="element-227" />
                  </div>)}
            </div>
          </div>

          {/* Afeitado Tradicional card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="relative border-2 border-rotterdam-gold pearl-border p-8 overflow-hidden transition-colors duration-300 flex flex-col h-full" data-id="element-228">
            <img src={services[1].bgImage} alt="" className="absolute inset-0 w-full h-full object-cover opacity-40" data-id="element-229" />
            <div className="absolute inset-0 bg-rotterdam-black/40" data-id="element-230" />
            <div className="relative z-10" data-id="element-231">
              <Sparkles className="w-10 h-10 text-rotterdam-gold pearl-icon mb-6" data-id="element-232" />
              <h3 className="text-2xl font-serif font-semibold mb-4" data-id="element-233">
                {services[1].title}
              </h3>
              <p className="text-rotterdam-cream/90 leading-relaxed" data-id="element-234">
                {services[1].desc}
              </p>
            </div>
          </motion.div>

          {/* Marquee gallery below Afeitado Tradicional */}
          <div className="overflow-hidden w-full" data-id="element-235">
            <div className="flex animate-marquee gap-4" style={{
            width: 'max-content'
          }} data-id="element-236">
              {[...shavingGalleryImages, ...shavingGalleryImages, ...shavingGalleryImages].map((img, index) => <div key={index} className="flex-shrink-0 w-64 h-80 overflow-hidden border border-rotterdam-gold/30 group relative" data-id="element-237">
                  <img src={img} alt={`Afeitado Rotterdam ${index % shavingGalleryImages.length + 1}`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-238" />
                  <div className="absolute inset-0 bg-[#6BB8D4]/0 group-hover:bg-[#6BB8D4]/10 transition-colors duration-300" data-id="element-239" />
                </div>)}
            </div>
          </div>

          {/* Getting Ready card */}
          <motion.div id="getting-ready" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="relative border-2 border-rotterdam-gold pearl-border p-8 overflow-hidden transition-colors duration-300 flex flex-col h-full" data-id="element-240">
            <img src="https://cdn.magicpatterns.com/uploads/6B5ar7Yz3F31jBS4DtB9sR/baner_bodaa.png" alt="" className="absolute inset-0 w-full h-full object-cover opacity-40" data-id="element-241" />
            <div className="absolute inset-0 bg-rotterdam-black/40" data-id="element-242" />
            <div className="relative z-10" data-id="element-243">
              <Wine className="w-10 h-10 text-rotterdam-gold pearl-icon mb-6" data-id="element-244" />
              <h3 className="text-2xl font-serif font-semibold mb-4" data-id="element-245">
                {services[2].title}
              </h3>
              <p className="text-rotterdam-cream/90 leading-relaxed flex-grow" data-id="element-246">
                {services[2].desc}
              </p>
            </div>
          </motion.div>

          {/* Marquee gallery below Getting Ready */}
          <div className="overflow-hidden w-full" data-id="element-247">
            <div className="flex animate-marquee gap-4" style={{
            width: 'max-content'
          }} data-id="element-248">
              {['https://cdn.magicpatterns.com/uploads/52XjYxBwShav7BPKm8tGex/boda_1.png', 'https://cdn.magicpatterns.com/uploads/r6ignZAJ6f3kXaqyCMCuYX/boda_2.png', 'https://cdn.magicpatterns.com/uploads/hxcoWc9d9cJ32URVwjqaCZ/boda_4.png', 'https://cdn.magicpatterns.com/uploads/mLwgyYEYp1KedcbcQXaGW1/boda_5.png', 'https://cdn.magicpatterns.com/uploads/x4Fw6pcDU8SV9tpMQt1y3M/boda_6.png', 'https://cdn.magicpatterns.com/uploads/iqbi1EpsyvKNsbKRmcHUJW/boda7.png', 'https://cdn.magicpatterns.com/uploads/52XjYxBwShav7BPKm8tGex/boda_1.png', 'https://cdn.magicpatterns.com/uploads/r6ignZAJ6f3kXaqyCMCuYX/boda_2.png', 'https://cdn.magicpatterns.com/uploads/hxcoWc9d9cJ32URVwjqaCZ/boda_4.png', 'https://cdn.magicpatterns.com/uploads/mLwgyYEYp1KedcbcQXaGW1/boda_5.png', 'https://cdn.magicpatterns.com/uploads/x4Fw6pcDU8SV9tpMQt1y3M/boda_6.png', 'https://cdn.magicpatterns.com/uploads/iqbi1EpsyvKNsbKRmcHUJW/boda7.png', 'https://cdn.magicpatterns.com/uploads/52XjYxBwShav7BPKm8tGex/boda_1.png', 'https://cdn.magicpatterns.com/uploads/r6ignZAJ6f3kXaqyCMCuYX/boda_2.png', 'https://cdn.magicpatterns.com/uploads/hxcoWc9d9cJ32URVwjqaCZ/boda_4.png', 'https://cdn.magicpatterns.com/uploads/mLwgyYEYp1KedcbcQXaGW1/boda_5.png', 'https://cdn.magicpatterns.com/uploads/x4Fw6pcDU8SV9tpMQt1y3M/boda_6.png', 'https://cdn.magicpatterns.com/uploads/iqbi1EpsyvKNsbKRmcHUJW/boda7.png'].map((img, index) => <div key={index} className="flex-shrink-0 w-64 h-80 overflow-hidden border border-rotterdam-gold/30 group relative" data-id="element-249">
                  <img src={img} alt={`Getting Ready ${index % 5 + 1}`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-250" />
                  <div className="absolute inset-0 bg-[#6BB8D4]/0 group-hover:bg-[#6BB8D4]/10 transition-colors duration-300" data-id="element-251" />
                </div>)}
            </div>
          </div>

          {/* Barra Rotterdam card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="relative border-2 border-rotterdam-gold pearl-border p-8 overflow-hidden transition-colors duration-300 flex flex-col h-full" data-id="element-252">
            <img src={services[3].bgImage} alt="" className="absolute inset-0 w-full h-full object-cover opacity-40" data-id="element-253" />
            <div className="absolute inset-0 bg-rotterdam-black/40" data-id="element-254" />
            <div className="relative z-10" data-id="element-255">
              <Beer className="w-10 h-10 text-rotterdam-gold pearl-icon mb-6" data-id="element-256" />
              <h3 className="text-2xl font-serif font-semibold mb-4" data-id="element-257">
                {services[3].title}
              </h3>
              <p className="text-rotterdam-cream/90 leading-relaxed flex-grow" data-id="element-258">
                {services[3].desc}
              </p>
            </div>
          </motion.div>

          {/* Marquee gallery below Barra Rotterdam */}
          <div className="overflow-hidden w-full" data-id="element-259">
            <div className="flex animate-marquee gap-4" style={{
            width: 'max-content'
          }} data-id="element-260">
              {['https://cdn.magicpatterns.com/uploads/aTWE8R912bk6QUYp43Q7Bc/trago_3.png', 'https://cdn.magicpatterns.com/uploads/nTQuZ2RARvNnvAh4EExb1M/trago_1.png', 'https://cdn.magicpatterns.com/uploads/2qmFUzSvZmompH6ub6zC6T/trago4.png', 'https://cdn.magicpatterns.com/uploads/5u661aijpX7RFya2rwcvBP/trago_5.png', 'https://cdn.magicpatterns.com/uploads/uUK7BABcX7QSmUrrEZNYk7/trgo_2.png', 'https://cdn.magicpatterns.com/uploads/7tog5y3iaQsQGFKxoLnKC8/trago_6.png', 'https://cdn.magicpatterns.com/uploads/sGpezLJ1dyHfqomzfiixcV/trago_8.png', 'https://cdn.magicpatterns.com/uploads/44H6evbh8Sjecajf6pRWx7/trago7.png', 'https://cdn.magicpatterns.com/uploads/aTWE8R912bk6QUYp43Q7Bc/trago_3.png', 'https://cdn.magicpatterns.com/uploads/nTQuZ2RARvNnvAh4EExb1M/trago_1.png', 'https://cdn.magicpatterns.com/uploads/2qmFUzSvZmompH6ub6zC6T/trago4.png', 'https://cdn.magicpatterns.com/uploads/5u661aijpX7RFya2rwcvBP/trago_5.png', 'https://cdn.magicpatterns.com/uploads/uUK7BABcX7QSmUrrEZNYk7/trgo_2.png', 'https://cdn.magicpatterns.com/uploads/7tog5y3iaQsQGFKxoLnKC8/trago_6.png', 'https://cdn.magicpatterns.com/uploads/sGpezLJ1dyHfqomzfiixcV/trago_8.png', 'https://cdn.magicpatterns.com/uploads/44H6evbh8Sjecajf6pRWx7/trago7.png', 'https://cdn.magicpatterns.com/uploads/aTWE8R912bk6QUYp43Q7Bc/trago_3.png', 'https://cdn.magicpatterns.com/uploads/nTQuZ2RARvNnvAh4EExb1M/trago_1.png', 'https://cdn.magicpatterns.com/uploads/2qmFUzSvZmompH6ub6zC6T/trago4.png', 'https://cdn.magicpatterns.com/uploads/5u661aijpX7RFya2rwcvBP/trago_5.png', 'https://cdn.magicpatterns.com/uploads/uUK7BABcX7QSmUrrEZNYk7/trgo_2.png', 'https://cdn.magicpatterns.com/uploads/7tog5y3iaQsQGFKxoLnKC8/trago_6.png', 'https://cdn.magicpatterns.com/uploads/sGpezLJ1dyHfqomzfiixcV/trago_8.png', 'https://cdn.magicpatterns.com/uploads/44H6evbh8Sjecajf6pRWx7/trago7.png'].map((img, index) => <div key={index} className="flex-shrink-0 w-64 h-80 overflow-hidden border border-rotterdam-gold/30 group relative" data-id="element-261">
                  <img src={img} alt={`Barra Rotterdam ${index % 5 + 1}`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-262" />
                  <div className="absolute inset-0 bg-[#6BB8D4]/0 group-hover:bg-[#6BB8D4]/10 transition-colors duration-300" data-id="element-263" />
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}